import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const CLOSURETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ClosureType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const CLOSURETYPE_CONFIG = {
  entityName: 'ClosureType',
  localizationKey: 'Controlling::Entity.ClosureType',
  fields: CLOSURETYPE_FIELDS,
  permission: 'ControllingLiquidations.ClosureTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
